import { Component } from '@angular/core';

@Component({
  selector: 'loading-dots',
  templateUrl: './loading-dots.component.html',
  styleUrls: ['./loading-dots.component.scss'],
  standalone: false
})
export class LoadingDotsComponent {}
